import { FC, useCallback, useContext, useEffect } from "react";

import { IPlayer } from "../../../interfaces";

import ReadyCheckIcon from '../../../assets/icons/ReadyCheckIcon.svg';
import { SocketContext } from "../../../context";

type alignData = "main" | "list" | "singlePicture";

interface UserProps {
	type: alignData;
	playerData: IPlayer;
	index?: number;
	isProfilePictureUpdated?: any;
}

const User: FC<UserProps> = (props) => {
	const { playerData, type, index, isProfilePictureUpdated } = props;
	const { profilePicturesNeedUpdateSocketOn } = useContext(SocketContext);

	const updateImage = useCallback(() => {
		var image: any = document.getElementById(`refreshTheListOfPlayersImage${index}`);
		if ( image !== 'undefined' && image !== null ) {  
		image.src = image.src.split("?")[0] + "?" + new Date().getTime();
		}

		var imageTwo: any = document.getElementById("refreshTheHeaderProfileImage");
		if ( imageTwo !== 'undefined' && imageTwo !== null ) {  
		imageTwo.src = imageTwo.src.split("?")[0] + "?" + new Date().getTime();
		}
	}, [index]);

	useEffect( () => {
		profilePicturesNeedUpdateSocketOn();
	}, [profilePicturesNeedUpdateSocketOn]);

	useEffect(() => {
		updateImage();
	}, [isProfilePictureUpdated, updateImage]);

	const displayStyle = () => {
		if (type === "list")
			return listOfPlayers(); 
		
		if (type === "singlePicture")
			return singlePicture();
	};

	const singlePicture = () => {
		return (
			<div className={`user_list_image center_horizontally_and_vertically`}>
				<img className={`user_list_image-style  border_color_${playerData?.color} `} src={`${process.env.REACT_APP_BACKEND_URL}images/${playerData?.email}.png`} alt="Profile Icon" />
			</div>
		);
	}

	const listOfPlayers = () => {
		return (
			<div className="user_list_item" style={{ height: "4.7vw" }}>

				<div className="user_list_item_mini_profile_wrapper">
					<div className={`user_list_item_image center_horizontally_and_vertically border_color_${playerData?.color}`} style={{ width: "4vw", height: "4vw" }}>
						<img id={`refreshTheListOfPlayersImage${index}`} className="user_player_list_image" src={`${process.env.REACT_APP_BACKEND_URL}images/${playerData?.email}.png`} alt="Profile Icon" />
					</div>
					<div className="user_list_item_info">
						<p className="user_list_item_info_name"> {playerData.nickname} </p>
						<p className="user_list_item_info_email lobby_gray_color"> { playerData.email.length < 20 ? playerData.email : playerData.email.substring(0, 19) + "..." } </p>
					</div>
				</div>

				<div className="user_list_item_check">
					{playerData.isReady ?
						<img className="edit_pen" src={ReadyCheckIcon} alt="edit pen" style={{ width: "25px" }} />
						:
						<div> </div>
					}
				</div>

			</div>

		);
	};

	return (
		<div>{displayStyle()}</div>
	) 
};

export default User;
